import Reflux from 'reflux';
import ProveedoresActions from '../ProveedoresActions';
import AlertActions from '../AlertActions';
import ErrorHandlerStore from './ErrorHandlerStore';
import Proveedor from '../../Models/Proveedor';
import http from '../../services/fetch';
import AuthStore from './AuthStore';


var ProveedoresStore = Reflux.createStore({
    init: function() {
        this.listenToMany(ProveedoresActions);
        this.listenTo(AuthStore, this.handleAuth);
        this.take = 8;
    },

    handleAuth(e, user){
        if (e === 'auth_success') {
            this.proxima_retiva = user.cliente.correlativos.proxima_ret_iva;
            this.proxima_ret_renta = user.cliente.correlativos.proxima_ret_renta;
        }
            
    },

    /**
     * Make a GET request to the server to obtain all Proveedor
     * 
     */
    getProveedores: function(count) {
        let take = '';
        if (this.take || count) {
            this.take = (this.take || 0) + parseInt(count || 0);
            take = '?take='+this.take;
        }
        http.get('proveedores'+take, this._getToken())
        .then(ErrorHandlerStore.checkForErrors)
        .then((json) => {
            this.proveedores = json.proveedores.map((proveedor) => new Proveedor(proveedor));
            this.trigger('getProveedores', this.proveedores, json.count, this.proxima_retiva, this.proxima_ret_renta);
        });
    },

    /**
     * Make a GET request to the server to obtain a single Proveedor
     * 
     */
    getProveedor: function(id, tipos) {
        let types = '';
        if (tipos) types = '?tipos_retencion=true';
        http.get('proveedor/'+id+types,this._getToken())
        .then(ErrorHandlerStore.checkForErrors)
            .then((json) => {
                let tipos = [];



                if (json.tipos_retencion) {
                    let label = function() { return this.codigo + ' - '+this.porcentaje+ '% - ' + this.descripcion;};
                    tipos = json.tipos_retencion.map((tipo) => {
                        tipo.label = label;
                        tipo.codigo = tipo.codigo_seniat;
                        return tipo;
                    });
                }

                this.proveedor = new Proveedor(json.proveedor);

                this.trigger('getProveedor', this.proveedor,null, this.proxima_retiva, this.proxima_ret_renta, tipos);
            });
    },

    /**
     * Make POST request to the server to create a new Proveedor
     * 
     * @param {Proveedor} body The request body of the Proveedor that's going 
     * to be created.
     * 
     */
    postProveedor: function(body) {
        http.post('proveedores', body, this._getToken())
        .then(ErrorHandlerStore.checkForErrors)
        .then((json) => {
            this.proveedor = json;
            this.trigger('postedProveedor', this.proveedor);
        });
    },

    /**
     * Make PUT request to the server to update a Proveedor
     * 
     * @param {Proveedor} body The request body of the Proveedor that's going 
     * to be updated.
     * 
     */
    putProveedor: function(body) {
        http.put('proveedor/'+body.id, body, this._getToken())
        .then(ErrorHandlerStore.checkForErrors)
        .then((json) => {
            this.proveedor = new Proveedor(json);
            this.trigger('putProveedor', this.proveedor);
        });
    },

    /**
     * Delete request to destroy a proveedor
     *
     */
    deleteProveedor: function(proveedor) {
        http.delete('proveedor/'+proveedor.id, this._getToken())
        .then(ErrorHandlerStore.checkForErrors)
        .then((json) => {
            ProveedoresActions.getProveedores();
            this.trigger('deletedProveedor', proveedor);
        });
    },

    getProximaRetencion: function() {
        let proxima = 1509;
        return proxima;
    },

    /**
     * Handles search according to query received from TextField
     * 
     * @param e Event: TextField in which the query is being typed
     */
    apiFilter: function(q) {
        http.get('proveedores?query='+q, this._getToken())
        .then(ErrorHandlerStore.checkForErrors)
        .then((json) => {
            this.proveedores = json.proveedores.map((proveedor) => new Proveedor(proveedor));
            this.trigger('getProveedores', this.proveedores, json.count);
        });
    },

    /**
     * Handles search according to query received from TextField
     * 
     * @param e Event: TextField in which the query is being typed
     */
    filter: function(e) {
        let query = e.target.value,
        list = this.proveedores,
        reg = new RegExp(query, 'gi');
        
        list = list.filter(
            (item, index) => item.primaryText.match(reg) || item.secondaryText.match(reg)
        );

        this.trigger('filter', list);
    },

    _getToken: function() {
        return localStorage.getItem('access_token');
    },

    getRif: function(rif) {
        this._timeout(10000, http.get(/rif/+rif))
        .then(ErrorHandlerStore.checkForErrors)
        .then((json) => {
            console.log(json);
            let data = json;
            if (data.rif[0] === 'J' && data.nombre.indexOf('(') !== -1) {
                const i = data.nombre.indexOf('(');
                data.nombre = data.nombre.substr(0,i-1);
            }
            this.rifdata = data;
            this.trigger('getRif', this.rifdata);
        })
        .catch((error) => {
            console.log(error);

            ErrorHandlerStore.checkForErrors({error: 'timeout-seniat'});
 
        });

    },

    _timeout: function (ms, promise) {
        return new Promise(function(resolve, reject) {
            setTimeout(function() {
            reject(new Error("timeout"));
            }, ms);
            promise.then(resolve, reject);
        });
    }
});

export default ProveedoresStore;


/** WEBPACK FOOTER **
 ** ./app-react/reflux/stores/ProveedorStore.js
 **/